<!-- eslint-disable no-irregular-whitespace -->
<template>
    <div class="exploration-wrapper">
        <div class="exploration-container">
            <div class="page-title-container">
                <p class="page-title">Dive into Hedlyner's Possibilities</p>
            </div>
            <div class="exploration-body">
                <div class="exploration-card">
                    <div class="card-title">Discover Artists</div>
                    <div class="card-slider">
                        <ImageCarousel :images="artistImages" />
                        <!-- TODO: Add the functionality for real data in the artist, venue, opportunities and events cards-->
                        <!-- 
                        <Artist
                            v-for="(user, indx) in filteredArtists"
                            :key="indx"
                            :user="user"
                        />
                        -->
                    </div>
                    <div class="card-description">
                        Explore a range of artist profiles on Hedlyner. Dive into their music,
                        get a feel for their style, and find artists who are the right fit for
                        your next event.
                    </div>
                    <button class="action-btn" @click="searchPage">
                        <span class="btn-text">Explore Artists</span>
                    </button>
                </div>
                <div class="exploration-card">
                    <div class="card-title">Find New Venues</div>
                    <div class="card-slider">
                        <ImageCarousel :images="venueImages" />
                        <!-- TODO: Add the functionality for real data in the artist, venue, opportunities and events cards-->
                        <!-- 
                        <Venue
                            v-for="(user, indx) in filteredVenues"
                            :key="indx"
                            :user="user"
                        />
                        -->
                    </div>
                    <div class="card-description">
                        Artists, browse through profiles of diverse venues on Hedlyner, each
                        with its unique ambiance. Connect with venues that complement your
                        style and are seeking talent like yours for their next live music
                        event.
                    </div>
                    <button class="action-btn violet" @click="venuesPage">
                        <span class="btn-text">Search Venues</span>
                    </button>
                </div>
                <div class="exploration-card">
                    <div class="card-title">Explore Opportunities</div>
                    <div class="card-slider">
                        <ImageCarousel :images="opportunityImages" />
                    </div>
                    <div class="card-description">
                        Explore opportunities that could be your next stage. Hedlyner lists
                        a variety of events from local venues, each offering a chance
                        to perform and connect with new fans. Find opportunities tailored
                        to your genre and make your mark in the live music scene.
                    </div>
                    <button class="action-btn" @click="opportunitiesPage">
                        <span class="btn-text">Find Opportunities</span>
                    </button>
                </div>
                <div class="exploration-card">
                    <div class="card-title">Discover Events Near You</div>
                    <div class="card-slider">
                        <ImageCarousel :images="eventImages" />
                    </div>
                    <div class="card-description">
                        Engage with the vibrant indie music scene on Hedlyner. Discover new
                        venues and up-and-coming artists through our curated events. From cozy
                        local spots to exciting indie showcases, there’s always a stage
                        to perform on or a new act to enjoy.
                    </div>
                    <button class="action-btn violet">
                        <!-- add this later: @click="eventsPage"-->
                        <span class="btn-text">Coming Soon</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // TODO: Add the functionality for real data in the artist, venue, opportunities and events cards
    /*import axios from 'axios'
    import { notification } from '@/helpers/notification'
    import Venue from '../search-result-venue/Venue.vue'
    import Artist from '../search-result-artist/Artist.vue'*/
    import ImageCarousel from './ImageCarousel.vue'
    import artist1 from './../../../images/exploration/artist1.png'
    import artist2 from './../../../images/exploration/artist2.png'
    import artist3 from './../../../images/exploration/artist3.png'
    import artist4 from './../../../images/exploration/artist4.png'
    import artist5 from './../../../images/exploration/artist5.png'
    import venue1 from './../../../images/exploration/Venue1.png'
    import venue2 from './../../../images/exploration/Venue2.png'
    import venue3 from './../../../images/exploration/Venue3.png'
    import venue4 from './../../../images/exploration/Venue4.png'
    import venue5 from './../../../images/exploration/Venue5.png'
    import event1 from './../../../images/exploration/Event1.png'
    import event2 from './../../../images/exploration/Event2.png'
    import event3 from './../../../images/exploration/Event3.png'
    import event4 from './../../../images/exploration/Event4.png'
    import event5 from './../../../images/exploration/Event5.png'
    import opportunity1 from './../../../images/exploration/Opportunity1.png'
    import opportunity2 from './../../../images/exploration/Opportunity2.png'
    import opportunity3 from './../../../images/exploration/Opportunity3.png'
    import opportunity4 from './../../../images/exploration/Opportunity4.png'
    import opportunity5 from './../../../images/exploration/Opportunity5.png'
    export default {
        name: 'exploration',
        components: {
            ImageCarousel
            //TODO: Add the functionality for real data in the artist, venue, opportunities and events cards,
            //Artist,
            //Venue
        },
        data: () => ({
            artistImages: [artist1, artist2, artist3, artist4, artist5],
            venueImages: [venue1, venue2, venue3, venue4, venue5],
            eventImages: [event1, event2, event3, event4, event5],
            opportunityImages: [
                opportunity1,
                opportunity2,
                opportunity3,
                opportunity4,
                opportunity5
            ]
            //TODO: Add the functionality for real data in the artist, venue, opportunities and events cards,
            /*authed: false,
            searchParams: {},
            defaultSearchParams: {
                location: '',
                city: '',
                lat: '',
                lon: '',
                search: '',
                date: ''
            },
            currentLocation: '',
            filterVenueResult: [],
            load: false*/
        }),
        methods: {
            // TODO: Add the functionality for real data in the artist, venue, opportunities and events cards
            /*async getVenuesList() {
                try {
                    const response = await axios.get('/api/search/venues', {
                        params: this.searchParams
                    })
                    this.filterVenueResult = response.data.data.featured_venues //TODO: Change this to result when the API get request changes
                    this.load = true
                    console.log(response)
                } catch (error) {
                    notification('error', error.response.data.errors.message)
                }
            },
            async getArtistsList() {
                try {
                    const response = await axios.get('/api/search/artists', {
                        params: this.searchParams
                    })
                    this.filterArtistResult = response.data.data.result
                    this.currentLocation = response.data.data.location.location
                    localStorage.setItem('currentLocation', this.currentLocation)
                    this.load = true
                } catch (error) {
                    notification('error', error.response.data.errors.message)
                }
            },*/
            searchPage() {
                window.location.href = '/search'
            },
            venuesPage() {
                window.location.href = '/venue-search'
            },
            opportunitiesPage() {
                window.location.href = '/opportunities'
            },
            eventsPage() {
                window.location.href = '/events'
            }
        }
        // TODO: Add the functionality for real data in the artist, venue, opportunities and events cards
        /*,
        computed: {
            filteredArtists() {
                return this.filterArtistResult
            },
            filteredVenues() {
                return this.filterVenueResult
            }
        },
        async created() {
            this.venuesList = JSON.parse(localStorage.getItem('venuesList'))
            this.venuesList = await this.getVenuesList()
        }*/
    }
</script>

<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';

    .exploration-wrapper {
        @include flex-col;
        align-items: center;
        gap: 64px;
        padding-bottom: 65px;
        min-height: 100vh;

        @media (max-width: $mobile) {
            min-height: revert;
        }

        .exploration-container {
            gap: 20px;
            width: 100%;
            max-width: 1050px;

            .page-title-container {
                @include flex-start;
                @include flex-col;
                width: 100%;

                .page-title {
                    @include page-headline;
                    align-self: start;
                }

                @media (max-width: $mobile) {
                    max-width: 336px;
                    padding: 24px;
                }
            }

            .exploration-body {
                @include flex-start;
                gap: 21px;
                align-self: stretch;
                flex-wrap: wrap;
                .exploration-card {
                    @include flex-col;
                    min-width: 448px;
                    padding: 32px;
                    align-items: center;
                    gap: 24px;
                    flex: 1 0 0;
                    border-radius: 32px;
                    border: 1px solid #333;
                    justify-content: space-between;
                    align-self: stretch;

                    @media (max-width: $mobile) {
                        min-width: 340px;
                        padding: 24px;
                    }

                    .card-title {
                        color: $white;
                        @include base-font-24;
                        font-weight: 600;
                        line-height: 28px;
                        letter-spacing: -0.48px;
                    }

                    .card-description {
                        color: $darker-grey;
                        @include base-font-16;
                        font-weight: 400;
                        line-height: 24px;
                    }

                    .action-btn {
                        display: flex;
                        padding: 11px 30px 12px 30px;
                        border: none;
                        justify-content: center;
                        align-items: center;
                        border-radius: 100px;
                        background: $lime;
                        .btn-text {
                            color: $black;
                            @include base-font-18;
                            line-height: 120%;
                        }
                        &.violet {
                            background: $violet;
                        }
                    }
                }
            }
        }
    }
</style>
